import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { SubmissionError, arrayPush, destroy, arrayRemoveAll } from 'redux-form';
import { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest, take } from 'redux-saga/effects';
import { getApartmentMedia } from '../actions/apartments';
import { closeDialog } from '../actions/dialogs';
import { createShowings, createShowingsFail, createShowingsSuccess, setShowingApplicants, setShowingApplicantsSuccess, setShowingApplicantsFail, denyReservable, denyReservableFail, denyReservableSuccess, getApartmentsShowings, getApartmentsShowingsFail, getApartmentsShowingsSuccess, getReserveDataSuccess, getApplicationsShowings, getApplicationsShowingsSuccess, getApplicationsShowingsFail, getShowings, getShowingsFail, getShowingsSuccess, reserveShowing, reserveShowingFail, reserveShowingSuccess, getUserShowingsSuccess, getUserShowingsFail, getUserShowings, addShowingToFieldArraySuccess, addShowingToFieldArrayFail, addShowingToFieldArray, getReserveDataFail, getReserveData, deleteShowingSuccess, deleteShowingFail, deleteShowing, deleteShowingFromFieldArray, deleteShowingFromFieldArraySuccess, getOpenShowings, getOpenShowingsSuccess, getOpenShowingsFail } from '../actions/showings';
import { addFormSubmit } from '../config/googleTagManager';
import { getLastWord } from '../libs/strings';
import { Action, ActionWithPayload } from '../reducers/types';
import { selectApartmentById, selectApartmentsAsArray } from '../selectors/apartments';
import { selectSelectedApplications } from '../selectors/applications';
// import { selectFormValues } from '../selectors/form'
import { selectApplicationCodeFromPathname, selectContentIdFromPathname, selectUserIdFromPathname, selectApartmentFromPathname, selectShowingFromPathname } from '../selectors/router';
import { selectReserveViewLogic, selectReserveData } from '../selectors/showings';
import { selectIsAdminUser } from '../selectors/users';
import ApartmentsApi from '../services/apartments';
import ShowingsApi, { DeleteShowingArgs } from '../services/showings';
import { getHistory } from '../store';
import i18n from '../translations/i18n';
// import { Apartment } from '../types/apartments'
import { FormPayloadParameters } from '../types/formData';
import { PayloadParameters } from '../types/payloads';
import { Showing, CreateShowing, ReserveData, AddShowingsFormData, DeleteShowingsFormData, FormShowing } from '../types/showings';
import { ReserveViewLogic, CreateShowingsFormState, IndexedShowingsInterfaces } from '../types/states';
import { getReservableApartmentIds } from '../utils/apartments';
import { generateCreateShowings, getShowingsInterface, getShowingsInterfacesIndexedByApartmentId } from '../utils/showings';
import { getFutureShowings } from '../utils/showings/filterAndSearch';
import { validateNoEmptyShowingsArray, validateCreateShowings } from '../utils/validation/showings';
import { acceptSelectedApplications } from './applications';
export function* handleGetShowings({ payload: { userId, apartmentId } }: any): SagaIterator {
    try {
        let showings = yield call(ShowingsApi.getShowings, userId, apartmentId);
        showings = showings.filter((showing: Showing) => showing.invitedApplicationIds);
        const showingsInterface = getShowingsInterface(showings);
        //  let showings = yield call(ShowingsApi.getShowings, userId, apartmentId)
        // showings = showings.filter(
        //   (showing: Showing) =>
        //     showing.applicationIds && showing.applicationIds?.length > 0
        // )
        yield put(getShowingsSuccess({ apartmentId, showingsInterface }));
    }
    catch (error: any) {
        yield put(getShowingsFail((error as any).message));
    }
}
export function* handleGetUserShowings(): SagaIterator {
    try {
        const showings = yield call(ShowingsApi.getUserShowings);
        const indexedShowingsInterfaces = getShowingsInterfacesIndexedByApartmentId(showings);
        yield put(getUserShowingsSuccess(indexedShowingsInterfaces));
    }
    catch (error: any) {
        yield put(getUserShowingsFail((error as any).message));
    }
}
/* this function is meant to get the number of reservable showings commission listing */
export function* HandleGetApartmentsShowings(): SagaIterator {
    try {
        const apartments = yield select(selectApartmentsAsArray);
        let indexedShowingsInterfaces: IndexedShowingsInterfaces = {};
        // get showings based on apartment metadata and status
        if (!apartments || apartments.length < 1) {
            throw new Error('no apartments');
        }
        const apartmentIdArray = getReservableApartmentIds(apartments);
        if (apartmentIdArray && apartmentIdArray.length > 0) {
            let showings: Showing[] = yield call(ShowingsApi.getShowingsByApartmentIdArray, apartmentIdArray);
            if (showings && showings.length > 0) {
                showings = showings.filter((showing: Showing) => showing.applicationIds && showing.applicationIds?.length > 0);
                indexedShowingsInterfaces = getShowingsInterfacesIndexedByApartmentId(showings);
            }
        }
        yield put(getApartmentsShowingsSuccess(indexedShowingsInterfaces));
    }
    catch (error: any) {
        yield put(getApartmentsShowingsFail((error as any).message));
    }
}
export function* handleGetApplicationsShowings({ payload: applicationCodes }: ActionWithPayload<string[]>): SagaIterator {
    try {
        const results: ReserveData[] = yield all(
            applicationCodes.map((code) => call(ShowingsApi.getShowingsByCode, code))
        );
        const indexed: Record<string, ReserveData> = {};
        applicationCodes.forEach((code, i) => {
            const data = results[i];
            if (data) {
                indexed[code] = data;
            }
        });
        yield put(getApplicationsShowingsSuccess(indexed));
    }
    catch (error: any) {
        yield put(getApplicationsShowingsFail((error as any).message));
    }
}
export function* handleGetReserveData({ payload: applicationCode }: Action): SagaIterator {
    try {
        const reserveData: ReserveData = yield call(ShowingsApi.getShowingsByCode, applicationCode);
        reserveData.invited = getFutureShowings(reserveData.invited || [], 'reserve', reserveData.application?.applicationId || '');
        const { apartment: { apartmentId } } = reserveData;
        yield put(getApartmentMedia(apartmentId));
        yield put(getReserveDataSuccess(reserveData));
    }
    catch (error: any) {
        const errorNum = getLastWord((error as any).message);
        yield put(getReserveDataFail(errorNum));
    }
}
export function* handleDenyReservable({ payload: type }: any): SagaIterator {
    try {
        const reserveViewLogicState: ReserveViewLogic = yield select(selectReserveViewLogic);
        let { bestReservableIndex, reservableIndex, loopedThrough } = reserveViewLogicState;
        const { bestReservableAmount, reservableAmount } = reserveViewLogicState;
        if (type === 'bestReservable') {
            bestReservableIndex++;
            if (bestReservableIndex === bestReservableAmount &&
                reservableAmount === 0) {
                bestReservableIndex = 0;
                reservableIndex = 0;
                loopedThrough = true;
            }
        }
        else {
            reservableIndex++;
            if (reservableIndex === reservableAmount) {
                bestReservableIndex = 0;
                reservableIndex = 0;
                loopedThrough = true;
            }
        }
        const reserveViewLogic = {
            bestReservableIndex,
            reservableIndex,
            loopedThrough
        };
        yield put(denyReservableSuccess(reserveViewLogic));
    }
    catch (error: any) {
        yield put(denyReservableFail((error as any).message));
    }
}
export function* handleReserveShowing({ payload: showingId }: PayloadParameters<string>): SagaIterator {
    try {
        const code = yield select(selectApplicationCodeFromPathname);
        const reserveBody = {
            showingId: showingId
        };
        const reserved = yield call(ShowingsApi.reserveShowing, code, reserveBody);
        const stateReserveData: ReserveData | Record<string, never> = yield select(selectReserveData);
        const reserveData = {
            ...stateReserveData,
            reserved
        };
        yield put(reserveShowingSuccess(reserveData));
        yield call(getHistory().push, '/home');
    }
    catch (error: any) {
        yield put(reserveShowingFail((error as any).message));
    }
}
/** if type is personal, only allow showings to be created for one day */
export function* handleAddShowingsToFieldArray({ payload: { formData, resolve, reject }, payload }: FormPayloadParameters<AddShowingsFormData>): SagaIterator {
    try {
        const { date, startDate: rawStartDate } = formData;
        const rawEndDate = dayjs(rawStartDate).add(1, 'm');
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const userId: string = yield select(selectUserIdFromPathname);
        yield put(getShowings({ userId, apartmentId }));
        const startDate = date
            .hour(rawStartDate.hour())
            .minute(rawStartDate.minute())
            .toISOString();
        const endDate = date
            .hour(rawEndDate.hour())
            .minute(rawEndDate.minute())
            .toISOString();
        // const { confirmation }: Apartment = yield select(
        //   selectApartmentById(apartmentId)
        // )
        const createShowings = generateCreateShowings(startDate, endDate, 'personal');
        validateNoEmptyShowingsArray(createShowings);
        yield take([getShowingsSuccess, getShowingsFail]);
        // const showingsInterface: ShowingsInterface = yield select(
        //   selectShowingsInterfaceByApartmentId(apartmentId)
        // )
        // const databaseExisting = getFutureShowings(
        //   showingsInterface.showings,
        //   'create'
        // )
        // const existingShowingsId = getShowingIdFromDateTime(
        //   databaseExisting,
        //   createShowings[0]?.startDate,
        //   createShowings[0]?.startDate
        // )
        const isAdmin: boolean = yield select(selectIsAdminUser);
        validateCreateShowings(createShowings, isAdmin);
        /** Incase of existing showing, redirect to edit it */
        // as now we dont show confirmed showings on calendar, no need in that feature
        // if (existingShowingsId) {
        //   yield call(getHistory().push, {
        //     pathname: `/users/${userId}/apartments/${apartmentId}/showings/${existingShowingsId}/edit`
        //   })
        // } else {
        // }
        yield all(createShowings.map((createShowing: CreateShowing) => put(arrayPush('CreateShowingsForm', 'showings', createShowing))));
        yield put(addShowingToFieldArraySuccess());
        addFormSubmit('addShowingsLocally');
        resolve();
    }
    catch (error: any) {
        yield put(addShowingToFieldArrayFail(error));
        if (payload?.formData?.directCreation)
            return error.errors._error;
        else {
            if (error?.errors?._error) {
                yield call(reject, new SubmissionError({
                    _error: i18n.t(`error.showings.${error.errors._error}`)
                }));
            }
            else {
                yield call(reject, new SubmissionError({
                    _error: i18n.t(`error.showings.general`)
                }));
            }
        }
    }
}
export function* handleDeleteShowingsFromFieldArray({ payload: { formData } }: FormPayloadParameters<DeleteShowingsFormData>): SagaIterator {
    yield put(arrayRemoveAll('CreateShowingsForm', 'showings'));
    const { startDate, showings } = formData;
    if (Array.isArray(showings) && showings.length > 1) {
        const index = showings.findIndex((element: FormShowing) => element.startDate === startDate.toString());
        if (index >= 0) {
            showings.splice(index, 1);
        }
        yield all(showings.map((createShowing: CreateShowing) => put(arrayPush('CreateShowingsForm', 'showings', createShowing))));
        yield put(deleteShowingFromFieldArraySuccess());
    }
}
export function* handleCreateShowings({ payload: { formData, resolve, reject } }: FormPayloadParameters<CreateShowingsFormState>): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const userId: string = yield select(selectUserIdFromPathname);
        const { showings: formShowings, confirmImmediately, selectedApplication } = formData;
        const createShowings = formShowings || [];
        // Skip redundant getShowings validation for direct creation (confirmImmediately)
        if (!confirmImmediately) {
            yield put(getShowings({ userId, apartmentId }));
            yield take([getShowingsSuccess, getShowingsFail]);
            const isAdmin: boolean = yield select(selectIsAdminUser);
            validateCreateShowings(createShowings, isAdmin);
        }
        const applications: string[] = selectedApplication || (yield select(selectSelectedApplications));
        if (!applications || applications.length === 0) {
            toast.error(i18n.t('error.showings.noApplicationsSelected'));
            yield call(getHistory().push, { pathname: `/users/${userId}/apartments/${apartmentId}/applications` });
            yield call(resolve);
            return;
        }
        const res = yield call(ShowingsApi.createShowings, userId, apartmentId, createShowings);
        yield put(createShowingsSuccess());
        yield put(closeDialog('ShowingsConfirmationDialog'));
        yield put(destroy('CreateShowingsForm'));
        // Update application status in store before navigating, so badges appear immediately
        yield call(acceptSelectedApplications, confirmImmediately, applications);
        const toastKey = confirmImmediately
            ? 'showings.createShowings.messages.confirmedImmediately'
            : 'showings.createShowings.messages.confirmed';
        toast.info(i18n.t(toastKey), { autoClose: false });
        yield call(getHistory().push, { pathname: `/users/${userId}/apartments/${apartmentId}/applications` });
        resolve();
        // Run remaining operations in background after user sees the result
        addFormSubmit('saveShowingsToDatabaseAndInviteApplicants');
        const apartmentState = yield select(selectApartmentById(apartmentId));
        if (!apartmentState?.metadata?.showings) {
            yield call(ApartmentsApi.updateMetadata, userId, apartmentId, 'showings');
        }
        /** Call setShowingApplicants, so applicants get added to invited array */
        yield all(res.map((element: Showing) => put(setShowingApplicants({
            applicationIds: applications,
            showingId: element.showingId,
            confirmImmediately,
            silent: true
        }))));
    }
    catch (error: any) {
        let errorCode: string | unknown;
        if (error?.response?.data?.message) {
            errorCode = error.response.data.message;
        }
        if (error?.errors?._error) {
            errorCode = error.errors._error;
        }
        yield put(createShowingsFail((error as any).message));
        const errorMessage = errorCode
            ? i18n.t(`error.showings.${errorCode}`)
            : i18n.t(`error.showings.general`);
        toast.error(errorMessage);
        if (reject)
            yield call(reject, new SubmissionError({
                _error: errorMessage
            }));
    }
}
export function* handleSetShowingApplicants({ payload: { applicationIds, showingId, confirmImmediately, silent } }: ActionWithPayload<{
    applicationIds: string[];
    showingId?: string;
    confirmImmediately?: boolean;
    silent?: boolean;
}>) {
    try {
        const apartmentId: string = yield select(selectApartmentFromPathname);
        const _showingId: string = showingId
            ? showingId
            : yield select(selectShowingFromPathname);
        const userId: string = yield select(selectUserIdFromPathname);
        if (!apartmentId || !_showingId || !applicationIds) {
            throw new Error('Missing props needed for deletion');
        }
        yield call(ShowingsApi.setShowingApplicants, apartmentId, _showingId, applicationIds, confirmImmediately);
        yield put(setShowingApplicantsSuccess());
        if (!silent) {
            yield call(acceptSelectedApplications, confirmImmediately, applicationIds);
            yield call(getHistory().push, {
                pathname: `/users/${userId}/apartments/${apartmentId}/applications`
            });
            if (confirmImmediately) {
                toast.info(i18n.t('showings.createShowings.messages.confirmedImmediately'), {
                    autoClose: false
                });
            }
            else {
                toast.info(i18n.t('showings.createShowings.messages.confirmed'), {
                    autoClose: false
                });
            }
        }
    }
    catch (error: any) {
        yield put(setShowingApplicantsFail(error));
        toast.error(i18n.t('error.showings.delete'));
    }
}
export function* handleDeleteShowing({ payload: { userId, apartmentId, showingId } }: ActionWithPayload<{
    userId: string;
    apartmentId: string;
    showingId: string;
}>) {
    try {
        if (!userId || !apartmentId || !showingId) {
            throw new Error('Missing props needed for deletion');
        }
        yield call(ShowingsApi.deleteShowing, {
            userId,
            apartmentId,
            showingId
        } as DeleteShowingArgs);
        yield put(deleteShowingSuccess({ apartmentId, showingId }));
        yield put(getShowings({ userId, apartmentId }));
        yield put(getOpenShowings({ userId, apartmentId }));
        yield take([getShowingsSuccess, getShowingsFail]);
        toast.success(i18n.t('showings.deleteSuccess'));
    }
    catch (error: any) {
        yield put(deleteShowingFail(error));
        yield put(getShowings({ userId, apartmentId }));
        toast.error(i18n.t('error.showings.delete'));
    }
}
export function* handleGetOpenShowings({ payload: { userId, apartmentId } }: any): SagaIterator {
    try {
        const allShowings: Showing[] = yield call(ShowingsApi.getShowings, userId, apartmentId);
        const showings = allShowings
            .filter((s: Showing) => s.type === 'openHouse')
            .map((s: Showing) => ({
                id: s.showingId,
                apartmentId: s.apartmentId,
                startDate: s.startDate,
                endDate: s.endDate,
                type: 'openHouse' as const,
                createdAt: s.createdAt
            }));
        yield put(getOpenShowingsSuccess({ apartmentId, showings }));
    } catch (error: any) {
        yield put(getOpenShowingsFail(error.message));
    }
}

function* watchShowingsActions(): SagaIterator {
    yield all([
        takeLatest(createShowings, handleCreateShowings),
        takeLatest(setShowingApplicants, handleSetShowingApplicants),
        takeLatest(getShowings, handleGetShowings),
        takeLatest(getUserShowings, handleGetUserShowings),
        takeLatest(getReserveData, handleGetReserveData),
        takeLatest(getApplicationsShowings, handleGetApplicationsShowings),
        takeLatest(getApartmentsShowings, HandleGetApartmentsShowings),
        takeLatest(denyReservable, handleDenyReservable),
        takeLatest(reserveShowing, handleReserveShowing),
        takeLatest(addShowingToFieldArray, handleAddShowingsToFieldArray),
        takeLatest(deleteShowingFromFieldArray, handleDeleteShowingsFromFieldArray),
        takeLatest(deleteShowing, handleDeleteShowing),
        takeLatest(getOpenShowings, handleGetOpenShowings)
    ]);
}
export default [watchShowingsActions];
